import { render, staticRenderFns } from "./CalculateGFR.vue?vue&type=template&id=19d9fd5a&scoped=true&"
import script from "./CalculateGFR.vue?vue&type=script&lang=js&"
export * from "./CalculateGFR.vue?vue&type=script&lang=js&"
import style0 from "./CalculateGFR.vue?vue&type=style&index=0&id=19d9fd5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d9fd5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDialog,VForm,VIcon,VLayout,VRadio,VRadioGroup,VTextField})
